export function getDefaultRoute(roles = []) {
    if (roles.includes("Super Admin")) {
        return "/accounting/sales";
    }

    // Astern Admin has no dashboard (hidden) — land on All Sales.
    if (roles.includes("Astern Admin")) {
        return "/accounting/sales";
    }

    if (roles.includes("Leader")) {
        return "/dashboard";
    }

    if (roles.includes("Accountant")) {
        return "/accounting/salesCommissions";
    }

    // All other roles (Sales Agent, In-house Agent, Group Admin, Admin, etc.)
    return "/dashboard";
};